import { z } from 'zod';

/**
 * Schema for data source subfolder data
 */
export const DataSourceSubfolderSchema = z.object({
  _id: z.string().optional(),
  id: z.string().optional(),
  parentFolderId: z.string(),
  name: z.string().max(50),
  description: z.string().max(200).optional(),
  companyId: z.string(),
});

/**
 * Schema for creating a data source subfolder
 */
export const CreateDataSourceSubfolderSchema = z.object({
  parentFolderId: z.string(),
  name: z.string().min(1).max(50),
  description: z.string().max(200).optional(),
});

export type DataSourceSubfolderDTO = z.infer<typeof DataSourceSubfolderSchema>;
export type CreateDataSourceSubfolderDTO = z.infer<
  typeof CreateDataSourceSubfolderSchema
>;
